import(/* webpackMode: "eager" */ "/vercel/path0/src/app/counselor/tasks/page.tsx");
